import { createRouter, createWebHistory } from 'vue-router'
import { canActivate } from '../services/auth-guard.service'
import MainLayout from "@/layouts/MainLayout.vue";
import NoMenuLayout from "@/layouts/NoMenuLayout.vue";

const routes = [
  {
    path: "/",
    component: NoMenuLayout,
    children: [
      { path: "", redirect: "/main" },
      { path: "init", component: () => import("@/views/Init.vue") },
      { path: "callback", component: () => import("@/views/Callback.vue") }
    ]
  },
  {
    path: "/main",
    component: MainLayout,
    children: [
      { path: "", name: "Home", component: () => import('@/views/Main.vue') },
      {
        path: "products",
        component: "",
        children: [
          { path: "", name: "Products", component: () => import('@/views/Products/Manage.vue') },
          { path: "new", name: "New Product", component: () => import('@/views/Products/New.vue') },
          { path: ":id", name: "Edit Product", component: () => import("@/views/Products/Edit.vue") }
        ]
      },
      {
        path: "categories",
        component: "",
        children: [
          { path: "", name: "Categories", component: () => import('@/views/Categories/Manage.vue') },
          { path: "new", name: "New Category", component: () => import('@/views/Categories/New.vue') },
          { path: ":id", name: "Edit Category", component: () => import("@/views/Categories/Edit.vue") },
          {
            path: ":id/propertygroups",
            component: "",
            children: [
              { path: "new", name: "New Property Group", component: () => import('@/views/Categories/PropertyGroups/New.vue') },
              { path: ":propertyGroupId", name: "Edit Property Group", component: () => import('@/views/Categories/PropertyGroups/Edit.vue') },
              {
                path: ":propertyGroupId/properties",
                component: "",
                children: [
                  { path: "", name: "Properties", component: () => import('@/views/Categories/PropertyGroups/Properties/Manage.vue') },
                  { path: "new", name: "New Property", component: () => import('@/views/Categories/PropertyGroups/Properties/New.vue') },
                  { path: ":propertyId", name: "Edit Property", component: () => import('@/views/Categories/PropertyGroups/Properties/Edit.vue') }
                ]
              }
            ],
          }
        ]
      },
      {
        path: "items",
        component: "",
        children: [
          { path: "", name: "Items", component: () => import('@/views/Items/Manage.vue') },
          { path: "new", name: "New Item", component: () => import('@/views/Items/New.vue') },
          { path: ":id", name: "Edit Item", component: () => import("@/views/Items/Edit.vue") }
        ]
      },
      {
        path: "productmodels",
        component: "",
        children: [
          { path: "", name: "Product Models", component: () => import('@/views/ProductModels/Manage.vue') },
          { path: "new", name: "New Product Model", component: () => import('@/views/ProductModels/New.vue') },
          { path: ":id", name: "Edit Product Model", component: () => import("@/views/ProductModels/Edit.vue") }
        ]
      },
      {
        path: "variants",
        component: "",
        children: [
          { path: "", name: "Variants", component: () => import('@/views/Variants/Manage.vue') },
          { path: "new", name: "New Variant", component: () => import('@/views/Variants/New.vue') },
          { path: ":id", name: "Edit Variant", component: () => import("@/views/Variants/Edit.vue") }
        ]
      },
      { path: "settings", name: "Settings", component: () => import('@/views/Settings/Main.vue') },
      {
        path: "webhooks",
        component: "",
        children: [
          { path: "", name: "Webhooks", component: () => import('@/views/Webhooks/Manage.vue') },
          { path: "new", name: "New Webhook", component: () => import('@/views/Webhooks/New.vue') },
          { path: ":id", name: "Edit Webhook", component: () => import("@/views/Webhooks/Edit.vue") }
        ]
      },
    ],
    beforeEnter: (to, from, next) => {
      next(canActivate())
    }
  },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Browser back/forward buttons
        if (savedPosition) {
            return savedPosition
        }

        // Scroll to top on route change
        return { top: 0 }
    }
});

router.afterEach((to) => {
  document.title = to.name ?? "PIM"
});

export default router
